<template>
  <div>
    <div class="header mb-4">
      <h1 class="header-title">Content Type Details</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Content Types</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Content Type Details
          </li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading">
            <a herf="#" @click.prevent="are_you_sure = true" class="btn btn-danger float-end"><i class="fal fa-trash"></i>Delete</a>
            <router-link :to="{ name: 'admin.types.edit' }" class="btn btn-primary float-end me-3"><i class="fal fa-pencil"></i>Edit</router-link>
            <h4>Name</h4>
            <p>{{ type.name }}</p>
            <h4>Pricing</h4>
            <table class="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Stars</th>
                  <th>No. Of Words</th>
                  <th>Price</th>
                  <th>Hours To Complete</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="type.pricing.length == 0">
                  <td colspan="5">There is no data to display</td>
                </tr>
                <tr v-for="(quality, i) in type.pricing" :key="`quality-${i}`">
                  <td>{{ quality.name }}</td>
                  <td>{{ quality.stars }}</td>
                  <td>{{ quality.words }}</td>
                  <td>{{ quality.price }}</td>
                  <td>{{ quality.hours }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
    <are-you-sure @cancel="are_you_sure = false" :show="are_you_sure" @confirm="destroy" id="delete_item" />
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      loading: true,
      type: { pricing: []},
      are_you_sure: false
    };
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$axios
        .get(`/api/v1/admin/types/${this.$route.params.id}`)
        .then((response) => {
          this.type = response.data.type;
          this.loading = false;
        });
    },

    destroy() {
      this.$axios
        .delete(`/api/v1/admin/types/${this.$route.params.id}`)
        .then(() => {
          this.$router.push({ name: 'admin.types' })
        });
    }
  },
};
</script>
